<template>
	<div class="col-sm-12 col-lg-1">
		<div class="datepicker" :class="{'datepicker-range':range,'datepicker__clearable':clearable&&text&&!disabled, open:show||type=='inline'}">
			<input
                    v-if="type!=='inline'"
                    ref="input"
                    readonly
                    :value="text"
                    :class="[show ? 'focus' : '', inputClass]"
                    :disabled="disabled"
				    :placeholder="placeholder"
                    :name="name"
            />

			<button
					class="datepicker-close"
					@click.stop="clearDate"
			/>

			<transition name="datepicker-anim">
				<div
                     v-if="show||type==='inline'"
                     class="datepicker-popup"
                     :class="[popupClass,{'datepicker-inline':type==='inline'}]"
                     tabindex="-1"
                >
					<template v-if="range">
						<vue-datepicker-local-calendar
							class="calendar calendar--from"
                            v-model="dates[0]"
                            :name="'from'"
                            :left="true"
                        />

						<vue-datepicker-local-calendar
							 class="calendar calendar--to"
                             v-model="dates[1]"
                             :name="'to'"
                             :right="true"
                        />
					</template>
					<template v-else>
						<vue-datepicker-local-calendar v-model="dates[0]"></vue-datepicker-local-calendar>
					</template>
					<div v-if="showButtons" class="datepicker__buttons">
						<button @click.stop="cancel" class="datepicker__button-cancel">{{ this.local.cancelTip }}
						</button>
						<button @click.stop="submit" class="datepicker__button-select">{{ this.local.submitTip }}
						</button>
					</div>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
	import VueDatepickerLocalCalendar from './VueDatepickerLocalCalendar.vue'

	export default {
		name: 'VueDatepickerLocal',
		components: { VueDatepickerLocalCalendar },
		props: {
			name: [String],
			inputClass: [String],
			popupClass: [String],
			value: [Date, Array, String],
			disabled: [Boolean],
			type: {
				type: String,
				default: 'normal'
			},
			rangeSeparator: {
				type: String,
				default: '~'
			},
			clearable: {
				type: Boolean,
				default: false
			},
			placeholder: [String],
			disabledDate: {
				type: Function,
				default: () => {
					return false
				}
			},
			format: {
				type: String,
				default: 'YYYY-MM-DD'
			},
			local: {
				type: Object,
				default () {
					return {
						dow: 1, // Sunday is the first day of the week
						hourTip: 'Select Hour', // tip of select hour
						minuteTip: 'Select Minute', // tip of select minute
						secondTip: 'Select Second', // tip of select second
						yearSuffix: '', // suffix of head year
						monthsHead: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), // months of head
						months: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), // months of panel
						weeks: 'Mo_Tu_We_Th_Fr_Sa_Su'.split('_'), // weeks,
						cancelTip: 'cancel',
						submitTip: 'confirm'
					}
				}
			},
			showButtons: {
				type: Boolean,
				default: false
			},
			dateRangeSelect: [Function]
		},
		data () {
			return {
				show: false,
				dates: this.vi(this.value)
			}
		},
		computed: {
			range () {
				return this.dates.length === 2
			},
			text () {
				const val = this.value
				const txt = this.dates.map(date => this.tf(date)).join(` ${ this.rangeSeparator } `)
				if (Array.isArray(val)) {
					return val.length > 1 ? txt : ''
				} else {
					return val ? txt : ''
				}
			}
		},
		watch: {
			value () {
				this.dates = this.vi(this.value)
			},
			'$store.state.events.dateText' (val) {
				if (val === '') {
					this.clearDate()
				}
			}
		},
		methods: {
			get () {
				if (this.dates[0] > this.dates[1]) {
					this.dates[1] = this.dates[0]
				}

				return Array.isArray(this.value) ? this.dates : this.dates[0]
			},
			clearDate () {
				this.$emit('input', this.range ? [] : '')
				this.$emit('removeRange')
				this.$store.commit('updateDateText', '')
			},
			vi (val) {
				if (Array.isArray(val)) {
					return val.length > 1 ? val.map(item => new Date(item)) : [new Date(), new Date()]
				} else {
					return val ? new Array(new Date(val)) : [new Date()]
				}
			},
			onDaySelected () {
				const $this = this
				$this.$emit('input', $this.get())
				!$this.showButtons && setTimeout(() => {
					$this.show = $this.range
				})
			},
			tf (time, format) {
				const year = time.getFullYear()
				const month = time.getMonth()
				const day = time.getDate()
				const hours24 = time.getHours()
				const hours = hours24 % 12 === 0 ? 12 : hours24 % 12
				const minutes = time.getMinutes()
				const seconds = time.getSeconds()
				const milliseconds = time.getMilliseconds()
				const dd = t => ('0' + t).slice(-2)
				const map = {
					YYYY: year,
					MM: dd(month + 1),
					MMM: this.local.months[month],
					MMMM: this.local.monthsHead[month],
					M: month + 1,
					DD: dd(day),
					D: day,
					HH: dd(hours24),
					H: hours24,
					hh: dd(hours),
					h: hours,
					mm: dd(minutes),
					m: minutes,
					ss: dd(seconds),
					s: seconds,
					S: milliseconds
				}
				return (format || this.format).replace(/Y+|M+|D+|H+|h+|m+|s+|S+/g, str => map[str])
			},
			dc (e) {
				if (this.show && (e.target === this.$refs.input)) {
					this.show = false
				} else {
					this.show = this.$el.contains(e.target) && !this.disabled
				}
			},
			submit () {
				this.$emit('confirm', this.get())
				this.show = false
				this.$store.commit('updateDateText', this.text)
			},
			cancel () {
				this.show = false
			}
		},
		mounted () {
			document.addEventListener('click', this.dc, true)
		},
		beforeDestroy () {
			document.removeEventListener('click', this.dc, true)
		}
	}
</script>

<style lang="scss">
	.datepicker {
		display: inline-block;
		width: 100%;
		position: relative;
	}

	.datepicker-close {
		display: none;
		position: absolute;
		top: 0;
		right: 0;
		width: 34px;
		height: 100%;

		border: none;
		background: transparent;
		cursor: pointer;
	}

	.datepicker-close::before {
		display: block;
		content: '';
		position: absolute;
		width: 16px;
		height: 16px;
		left: 50%;
		top: 50%;
		margin-left: -8px;
		margin-top: -8px;
		text-align: center;
		background: #ccc;
		color: #fff;
		border-radius: 50%;
		background: #ccc url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3IDciIHdpZHRoPSI3IiBoZWlnaHQ9IjciPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik01LjU4LDVsMi44LTIuODFBLjQxLjQxLDAsMSwwLDcuOCwxLjZMNSw0LjQxLDIuMiwxLjZhLjQxLjQxLDAsMCwwLS41OC41OGgwTDQuNDIsNSwxLjYyLDcuOGEuNDEuNDEsMCwwLDAsLjU4LjU4TDUsNS41OCw3LjgsOC4zOWEuNDEuNDEsMCwwLDAsLjU4LS41OGgwWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNSAtMS40OCkiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4NCg==') no-repeat 50% 50%;
	}

	.datepicker__clearable:hover::before {
		display: none;
	}

	.datepicker__clearable:hover .datepicker-close {
		display: block;
	}

	.datepicker-close:hover::before {
		background-color: #afafaf;
	}

	.datepicker > input {
		color: #666;
		transition: all 200ms ease;
		border: none;
		box-sizing: border-box;
		outline: none;
		padding: 0 15px;
		font-size: 14px;
		@media (max-width: 991.98px) {
			font-size: 16px;
		}
		width: 100%;
		height: 40px;
		user-select: none;
		-ms-user-select: none;
		-moz-user-select: none;
		-webkit-user-select: none;
	}

	.datepicker > input:disabled {
		cursor: not-allowed;
		background-color: #ebebe4;
		border-color: #e5e5e5;
		-webkit-box-shadow: none;
		box-shadow: none;
	}

	.datepicker-popup {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		position: absolute;
		transition: all 200ms ease;
		opacity: 1;
		transform: scaleY(1);
		transform-origin: center top;
		font-size: 12px;
		@media (max-width: 991.98px) {
			font-size: 16px;
		}
		outline: 0;
		overflow: hidden;
		z-index: 999;
		width: 413px;
		max-width: 413px;
	}

	.datepicker-inline {
		position: relative;
		margin-top: 0;
	}

	.datepicker-bottom {
		float: left;
		width: 100%;
		text-align: right;
	}

	.datepicker-btn {
		padding: 5px 10px;
		background: #1284e7;
		color: #fff;
		border-radius: 2px;
		display: inline-block;
		cursor: pointer;
	}

	.datepicker-anim-enter-active {
		transform-origin: 0 0;
		animation: datepicker-anim-in .2s cubic-bezier(.23, 1, .32, 1)
	}

	.datepicker-anim-leave-active {
		transform-origin: 0 0;
		animation: datepicker-anim-out .2s cubic-bezier(.755, .05, .855, .06)
	}

	.datepicker__buttons {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		text-align: right;
		background: transparent;
	}

	.datepicker__buttons button {
		display: inline-block;
		font-size: 13px;
		@media (max-width: 991.98px) {
			font-size: 16px;
		}
		border: none;
		cursor: pointer;
		margin: 10px 0 0 5px;
		padding: 5px 15px;
		color: #ffffff;
	}

	.datepicker__buttons .datepicker__button-select {
		background: #caa655;
	}

	.datepicker__buttons .datepicker__button-cancel {
		background: #666;
	}

	@keyframes datepicker-anim-in {
		0% {
			opacity: 0;
			transform: scaleY(.8)
		}
		to {
			opacity: 1;
			transform: scaleY(1)
		}
	}

	@keyframes datepicker-anim-out {
		0% {
			opacity: 1;
			transform: scaleY(1)
		}
		to {
			opacity: 0;
			transform: scaleY(.8)
		}
	}

	@media (max-width: 991.98px) {
		.datepicker {
			margin-bottom: 15px;
		}
	}

	@media (max-width: 443.98px) {
		.datepicker-popup {
			width: 100%;
		}
	}


	// arrow
	@media (max-width: 991.98px) {
		.datepicker::after {
			content: url(/static/img/mobile-arrow-down.png);
			position: absolute;
			top: 6px;
			right: 0;
			width: 30px;
			pointer-events: none;
		}

		.datepicker.open::after {
			transform: rotate(180deg);
			top: 12px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/EventsList/Filters/VueDatepickerLocal.vue